import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getMotivoContratacaoById, getStatusSolicitacaoById } from "./enums";
import { getMesTexto } from "../utils/functions";
import { Checkin, IconeMsgLida, IconeNaoMsgLida } from "../modules/comum/components/Icones";
import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake'
import _ from 'lodash';
import pdfFonts from 'pdfmake/build/vfs_fonts'
import { ExcelExport } from "@progress/kendo-react-excel-export";
import {
    LegendaEsgotadoCirculo,
    LegendaGoldCirculo,
    LegendaIndisponivelCirculo,
    LegendaNormalCirculo
} from "../modules/comum/components/Legenda";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { Table } from 'reactstrap';
import { Link } from "react-router-dom";

import Popup from '../modules/comum/components/Popup';

export let diasAlertaG = 1;

export const formataParaDiaMesAno = (data) => {
    if (data) {
        let formatoInicial = 'DD/MM/YYYY HH:mm:ss';
        let formatoFinal = 'DD MMM, YYYY';

        return moment(data, formatoInicial).format(formatoFinal);
    } else {
        return "";
    }
}

export const formataParaDiaMesAnoHoraMinuto = (data) => {
    if (data !== null) {
        
        let formatoFinal = 'DD/MM/YYYY HH:mm';

        return moment(data).format(formatoFinal);
    } else {
        return "";
    }
}

export const formataComTParaDiaMesAno = (data) => {
    let formatoFinal = 'DD MMM, YYYY';

    return moment(data).format(formatoFinal);
};

export const formataParaHoraMinSeg = (data) => {
    let formatoInicial = 'DD/MM/YYYY HH:mm:ss';
    let formatoFinal = 'HH:mm:ss';

    return moment(data, formatoInicial).format(formatoFinal);
}


export const formataParaHoraMin = (data) => {
    let formatoInicial = 'DD/MM/YYYY HH:mm';
    let formatoFinal = 'HH:mm';

    return moment(data, formatoInicial).format(formatoFinal);
}


export const qtdeMotsColuna = (cell, row, enumObject, rowIndex) => {
    return row.vencimentos.length;
};

export const valorTotalColuna = (cell, row, enumObject, rowIndex, tipo) => {
    var NumberFormat = require('react-number-format');
    let valor_total = row.vencimentos.reduce((total, obj) => {
        return total + obj.valor_vencimento;
    }, 0);

    if (tipo) {
        return formatarReal(valor_total);
    }

    return <NumberFormat value={valor_total} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','}
        prefix={'R$ '} decimalPrecision={2} />;
};

export const slaColuna = (cell, row, enumObject, rowIndex) => {
    let className = "circle ";
    if (row.sla == 0) className += " green";
    else if (row.sla == 1) className += " yellow";
    else className += " red";
    return <span className={className}></span>
};

export const statusTarefaColuna = (cell, row, enumObject, rowIndex) => {
    return row.statusTarefa === "Adquirida" ? <IconeMsgLida /> : <IconeNaoMsgLida />;
};

export const mesReferenciaColuna = (cell, row, enumObject, rowIndex) => {
    return row.ano_referencia + "/" + (row.mes_referencia < 10 ? "0" + row.mes_referencia : row.mes_referencia);
};

export const competenciaColuna = (cell, row, enumObject, rowIndex) => {
    return (row.mes_referencia < 10 ? "0" + row.mes_referencia : row.mes_referencia) + "/" + row.ano_referencia;
};

export const cpfProfissionalColuna = (cell, row, enumObject, rowIndex) => {
    return row.profissional.cpf;
};

export const nomeProfissionalColuna = (cell, row, enumObject, rowIndex) => {
    return row.profissional.nome;
};

export const valorVencimentoColuna = (cell, row, enumObject, rowIndex, tipo) => {
    if (tipo) {
        return formatarReal(row.valor_vencimento);
    }
    var NumberFormat = require('react-number-format');
    return <NumberFormat value={row.valor_vencimento} displayType={'text'} thousandSeparator={'.'}
        decimalSeparator={','} prefix={'R$ '} decimalPrecision={2} />;
};

export const formatarDataISO8601 = (data) => {
    if (data) {
        return moment(data).format("DD/MM/YYYY");
    }
};

export const formatarDataMicrosoftParaDataISO8601 = (data) => {
    if (data) {
        return moment(data).toISOString();
    }
};

export const converterDateParaMicrosoftDate = function (date) {
    var newDate = new Date(date.slice(6) + "-" + date.slice(3, 5) + "-" + date.slice(0, 2));
    return '/Date(' + (+newDate) + ')/';
};

export const converterISO8601ParaDuracao = function (iso8601duration, format) {
    return moment.utc(moment.duration(iso8601duration).asMilliseconds()).format(format)
};

export const converterStringToISO8601Duracao = function (duration) {
    return moment.duration(duration).toISOString();
};

export const converterMicrosoftDateParaString = function (microsoftDate, format) {
    return moment.utc(microsoftDate).format(format);
};

export const formatarDataMesAno = (data) => {
    if (data) {
        return moment(data).isValid() ? moment(data).format("MMM/YYYY") : moment(data, "MM/YYYY").isValid() ? moment(data, "MM/YYYY").format("MMM/YYYY") : "";
    }
};

export const formatarReal = (numero) => {
    if (numero || numero === 0) {
        if (typeof numero === 'string') numero = parseFloat(numero.replace('.', '').replace(',', '.'))
        var numero = numero.toFixed(2).split('.');
        numero[0] = "R$ " + numero[0].split(/(?=(?:...)*$)/).join('.');
        return numero.join(',');
    }
};

export const formatarRealSemCifrao = (numero) => {
    if (numero) {
        var numero = numero.toFixed(2).split('.');
        numero[0] = numero[0].split(/(?=(?:...)*$)/).join('.');
        return numero.join(',');
    }
};

export const formatarCnpj = (numero) => numero.padStart(14, '0').replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")

export const getRandomSubArray = (arr) => {
    if (arr) {
        let n = Math.floor(Math.random() * arr.length + 1);
        let result = new Array(n),
            len = arr.length,
            taken = new Array(len);
        while (n--) {
            const x = Math.floor(Math.random() * len);
            result[n] = arr[x in taken ? taken[x] : x];
            taken[x] = --len;
        }
        return result;
    } else {
        return [];
    }
};

export const arrayToString = (arr, attribute, nospaces) => {
    let arrAux = [];
    if (arr) {
        for (let i = 0; i < arr.length; i++) {
            arrAux.push(arr[i][attribute])
        }
    }
    if (nospaces) {
        return arrAux.join(",");
    } else {
        return arrAux.join(", ");
    }

};

export const enumArrayToEnumObject = (array) => {
    var objFormat = {};
    array.forEach(element => {
        objFormat[element.Key] = element.Value;
    });
    return objFormat;
};

export const reactSelectToEnumObject = (array) => {
    var objFormat = {};
    array.forEach(element => {
        objFormat[element.value] = element.label;
    });
    return objFormat;
};

export const createSelectOptions = (arr, value, label) => {
    const result = [];
    if (arr) {
        if (typeof label === "string") {
            for (let i = 0; i < arr.length; i++) {
                result.push({ "value": arr[i][value], "label": arr[i][label] })
            }
        } else {
            if (label) {
                for (let i = 0; i < arr.length; i++) {
                    const labelComposto = [];
                    for (let j = 0; j < label.length; j++) {
                        arr[i][label[j]]
                        if (arr[i][label[j]]) {
                            labelComposto.push(arr[i][label[j]])
                        }
                    }
                    result.push({ "value": arr[i][value], "label": labelComposto.join(" - ") })
                }
            }
        }
    }
    return result;
};

export const stringToArray = (arr, string, attribute) => {
    if (arr && string) {
        const result = [];
        const splitedString = string.split(",");
        for (let i = 0; i < splitedString.length; i++) {
            const object = arr.find(a => {
                return a[attribute] == splitedString[i]
            });
            if (object) {
                result.push(object)
            }
        }
        return result;
    }
};

export const getByAtribute = (arr, valueToFind, attribute) => {
    return arr.find(a => {
        return a[attribute] == valueToFind
    });
};

export const deleteByAtribute = (arr, valueToDelete, attribute) => {
    let indexToRemove = null;
    arr.forEach((a, index) => {
        if (a[attribute] == valueToDelete) {
            indexToRemove = index;
        }
    });

    if (indexToRemove) {
        arr.splice(indexToRemove, 1);
    }
};

export const listDiferencaByAtribute = (arr1, arr2, att1, att2) => {
    const result = [];
    let insere = false;
    arr1.forEach((value) => {
        insere = true;
        const attribute1 = att1 ? value[att1] : value;
        for (let i = 0; i < arr2.length; i++) {
            const attribute2 = att2 ? arr2[i][att2] : arr2[i];
            if (attribute1 === attribute2) {
                insere = false;
                break;
            }
        }
        if (insere) result.push(value);
    });
    return result;
};

export const listIgualdadeByAtribute = (arr1, arr2, att1, att2) => {
    const result = [];
    let insere = false;
    arr1.forEach((value) => {
        insere = false;
        const attribute1 = att1 ? value[att1] : value;
        for (let i = 0; i < arr2.length; i++) {
            const attribute2 = att2 ? arr2[i][att2] : arr2[i];
            if (attribute1 === attribute2) {
                insere = true;
                break;
            }
        }
        if (insere) result.push(value);
    });
    return result;
};

export const percentualFormat = (cell, nome) => {
    return cell.toFixed(1).replace('.', ',') + '%';
};

export const formatTelefone = (value) => {
    var re = /(\d?)(\d?)(\d?)(\d?)(\d?)(\d?)(\d?)(\d?)(\d?)(\d?)(\d?)/;
    var str = value.toString();
    if (str.length > 10) {
        return str.replace(re, '($1$2) $3$4$5$6$7-$8$9$10$11');
    } else {
        return str.replace(re, '($1$2) $3$4$5$6-$7$8$9$10');
    }
};

export const motivoContratacaoFormatter = (codigoMotivo) => {
    return getMotivoContratacaoById(codigoMotivo).valor;
};

export const statusSolicitacaoFormatter = (statusSolicitacao) => {
    return getStatusSolicitacaoById(statusSolicitacao).valor;
};

export const mudarDiasAlerta = (dias) => {
    diasAlertaG = dias;
}

export const slaFormatter = (totalDias, row) => {
    let title;
    let prazo = moment(row.prazo + ' 23:59:59', "DD/MM/YYYY hh:mm:ss");

    if (isNaN(prazo)) {
        var parsedData = new Date(row.prazo);
        var dataFormatada = parsedData.getDate() + "/" + (parsedData.getMonth() + 1) + "/" + parsedData.getFullYear();
        prazo = moment(dataFormatada + ' 23:59:59', "DD/MM/YYYY hh:mm:ss");
    }

    let agora = moment();
    //let prazo = agora.add(1, 'days');
    let diasAlerta = diasAlertaG;
    let duration = moment.duration(prazo.diff(agora));

    let sla = duration.days();

    if (sla < 0) title = "Prazo expirado";
    else if (sla <= diasAlerta) title = "Prazo expira hoje";
    else title = "Prazo expira em " + sla + " dias";

    const sqSize = 25;
    const strokeWidth = 3;
    //const totalDias = 2;
    const percentage = 1; //sla / totalDias;
    const radius = (sqSize - strokeWidth) / 2;
    const viewBox = `0 0 ${sqSize} ${sqSize}`;
    const dashArray = radius * Math.PI * 2;
    const dashOffset = dashArray - dashArray * percentage;
    let classname;
    if (sla < 0) classname = "stroke-red";
    else if (sla <= diasAlerta) classname = "stroke-yellow";
    else classname = "stroke-green";

    classname = ""; // removendo cor conforme solicitação do usuário

    if (sla < 0) sla = 0;

    return <div title={title}>
        <svg
            width={sqSize}
            height={sqSize}
            viewBox={viewBox}>
            <circle
                className="circle-background"
                cx={sqSize / 2}
                cy={sqSize / 2}
                r={radius}
                strokeWidth={`${strokeWidth}px`} />
            <circle
                className={`${classname} circle-progress`}
                cx={sqSize / 2}
                cy={sqSize / 2}
                r={radius}
                strokeWidth={`${strokeWidth}px`}
                // Start progress marker at 12 O'Clock
                transform={`rotate(-90 ${sqSize / 2} ${sqSize / 2})`}
                style={{
                    strokeDasharray: dashArray,
                    strokeDashoffset: dashOffset
                }} />
            <text
                className="circle-text"
                x="50%"
                y="50%"
                dy=".3em"
                textAnchor="middle">
                {`${sla}`}
            </text>
        </svg>
    </div>;
};

export const ordenarData = (a, b, order, fieldName) => {
    let dateA = moment(a[fieldName]).isValid() ? moment(a[fieldName]) :
        moment(a[fieldName], "DD/MM/YYYY").isValid() ? moment(a[fieldName], "DD/MM/YYYY") :
            moment(a[fieldName], "MM/YYYY").isValid() ? moment(a[fieldName], "MM/YYYY") : null;

    let dateB = moment(b[fieldName]).isValid() ? moment(b[fieldName]) :
        moment(b[fieldName], "DD/MM/YYYY").isValid() ? moment(b[fieldName], "DD/MM/YYYY") :
            moment(b[fieldName], "MM/YYYY").isValid() ? moment(b[fieldName], "MM/YYYY") : null;

    if (order === "asc") {
        if (dateA && dateA.isValid() && dateB && dateB.isValid()) {
            return dateA.isBefore(dateB) ? -1 : dateA.isSame(dateB) ? 0 : 1;
        } else if (dateA && dateA.isValid()) {
            return 1;
        } else {
            return -1;
        }

    } else {
        if (dateA && dateA.isValid() && dateB && dateB.isValid()) {
            return dateA.isBefore(dateB) ? 1 : dateA.isSame(dateB) ? 0 : -1;
        } else if (dateA && dateA.isValid()) {
            return -1;
        } else {
            return 1;
        }
    }
};

export const ordenarSLA = (a, b, order) => {
    let agora = moment();

    let prazo_a = moment(a.prazo + ' 23:59:59', "DD/MM/YYYY hh:mm:ss");
    let prazo_b = moment(b.prazo + ' 23:59:59', "DD/MM/YYYY hh:mm:ss");

    let duration_a = moment.duration(prazo_a.diff(agora));
    let duration_b = moment.duration(prazo_b.diff(agora));

    let sla_a = duration_a.days() + 1;
    let sla_b = duration_b.days() + 1;

    if (sla_a < 0) {
        sla_a = 0;
    }
    if (sla_b < 0) {
        sla_b = 0;
    }

    if (order === 'desc') {
        if (sla_a > sla_b) {
            return -1;
        } else if (sla_a < sla_b) {
            return 1;
        }
        return 0;
    }
    if (sla_a < sla_b) {
        return -1;
    } else if (sla_a > sla_b) {
        return 1;
    }
    return 0;
};


export const formatarCpf = (valor) => {
    if (!valor)
        return ''
    return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3\-\$4");
};

export const nullable = (valor) => {
    return valor ? valor : "";
};

export const formatarValorReal = (valor) => {
    let novoValor = valor ? valor : 0;
    return (novoValor).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    });
};

export const concatenarArrays = (arr, arr2) => {
    arr.push.apply(arr, arr2);
};

export const formatarDataMilisegundos = (data) => {
    return data ? moment(data).format('DD/MM/YYYY') : false;
}

export const inteiroPositivo = (valor) => {
    var num = parseInt(valor) || 0
    return Math.abs(num)
}

export const alphanumeric = (valor) => {
    let retorno = valor.replace(/[^a-z0-9]/gi, '');
    return retorno
};

export const formatarData = (data) => {
    let dataFormatada;

    if (data) {
        let parsedData = new Date(data);

        if (!isNaN(parsedData)) {
            let d = parsedData.getDate();
            if (d < 10) d = "0" + d;

            let m = getMesTexto(parsedData.getMonth() + 1);

            let minutes = parsedData.getMinutes();
            if (minutes < 10) minutes = "0" + minutes;

            let hours = parsedData.getHours();
            if (hours < 10) hours = "0" + hours;
            dataFormatada = <div className="data-cell">{d} {m}, {parsedData.getFullYear()}</div>;
        }
    }
    return dataFormatada;
};

export const formatarDataCustomHTML = (data) => {
    if (data === null) return "---";
    let dataFormatada;
    if (data) {
        let parsedData = new Date(data);

        if (!isNaN(parsedData)) {
            let d = parsedData.getDate();
            if (d < 10) d = "0" + d;

            let m = getMesTexto(parsedData.getMonth() + 1);

            let minutes = parsedData.getMinutes();
            if (minutes < 10) minutes = "0" + minutes;

            let hours = parsedData.getHours();
            if (hours < 10) hours = "0" + hours;
            dataFormatada = <div className="data-cell">{d} {m}, {parsedData.getFullYear()} <span> ({hours}:{minutes})</span></div>;
        }
    }

    return dataFormatada;
};

export const formatarDisabledRow = (cell, row) => {
    if (cell === null) return "---";
    return <div className={`data-cell ${row.DatInativo ? 'label-disabled' : 'label'}`}>{cell}</div>;
};

export const formatarDataCustomHTMLDisable = (cell, row) => {
    if (cell === null) return "---";
    let dataFormatada;
    if (cell) {
        let parsedData = new Date(cell);

        if (!isNaN(parsedData)) {
            let d = parsedData.getDate();
            if (d < 10) d = "0" + d;

            let m = getMesTexto(parsedData.getMonth() + 1);

            let minutes = parsedData.getMinutes();
            if (minutes < 10) minutes = "0" + minutes;

            let hours = parsedData.getHours();
            if (hours < 10) hours = "0" + hours;
            dataFormatada = <div className={`data-cell ${row.DatInativo ? 'label-disabled' : 'label'}`}>{d} {m}, {parsedData.getFullYear()} <span> ({hours}:{minutes})</span></div>;
        }
    }

    return dataFormatada;
};

export const formatarDataCustom = (data) => {
    if (data === null) return "---";
    let dataFormatada;
    if (data) {
        let parsedData = new Date(data);

        if (!isNaN(parsedData)) {
            let d = parsedData.getDate();
            if (d < 10) d = "0" + d;

            let m = getMesTexto(parsedData.getMonth() + 1);

            dataFormatada = `${d} ${m}, ${parsedData.getFullYear()}`;
        }
    }

    return dataFormatada;
};

export const formatarDataCustomHTMLSemHora = (data) => {
    if (data === null) return "---";
    let dataFormatada;
    if (data) {
        let parsedData = new Date(data);

        if (!isNaN(parsedData)) {
            let d = parsedData.getDate();
            if (d < 10) d = "0" + d;

            let m = getMesTexto(parsedData.getMonth() + 1);

            dataFormatada = <div className="data-cell">{d} {m}, {parsedData.getFullYear()}</div>;
        }
    }

    return dataFormatada;
};

export const formatarDiaMesAnoCustomHTML = (data) => {
    if (data === null || data === '-') return "---";
    return <div className="data-cell">{formataParaDiaMesAno(data)} <span> ({formataParaHoraMin(data)})</span></div>;
};

export const formatarCustomHTML = (data) => {
    if (data) {
        return <div>{data.join(' / ')}</div>
    }
};

export const formatarCheck = (data) => {
    return data[0] ? <Checkin /> : "---";
};

export const formataZero = (data) => {
    if (data[0] === 0) {
        return null
    } else {
        return data
    }
}

export const formatFieldDate = (dado, outroDado) => {
    if (Array.isArray(dado)) {
        if (dado.length === 0) return <div className="data-cell"> - </div>
        if (dado.length === 1) return <div className="data-cell"> {dado[0]} </div>
        return <div className="data-cell">{dado[0]} - {moment(data[1]).format("DD MMM YYYY (HH:mm)")}</div>
    } else {
        if (!dado || !outroDado) return <div className="data-cell"> - </div>
        return <div className="data-cell">{dado} - {moment(outroDado).format("DD MMM YYYY (HH:mm)")}</div>
    }
}

export const formatContainers = (dado) => {
    if (!dado) return <div> - </div>
    return <div>{dado.replace(/,/g, ' / ')}</div>
}

export const situacaoFormatter = (cell, row) => {
    if (!cell) return null;
    if (isArray(cell)) { cell = cell[0]; }

    let classe = cell.toLowerCase().replace(/\s|\./g, '-');
    classe = classe.replace('--', '-');
    if (cell.toLowerCase() === "fora do terminal") {
        cell = "Fora term."
    }

    return <div className={`situacao-btn ${classe}`}>{cell}</div>;

};

export const situacaoOrcamentoFormatter = (cell, row) => {
    if (cell === null) return null;
    if (isArray(cell)) { cell = cell[0]; }

    let classe = cell.toLowerCase().replace(/\s|\./g, '-');
    classe = classe.replace('--', '-');
    classe = classe.replace('.', '-');
    if (cell.toLowerCase() === "fora do terminal") {
        cell = "Fora term."
    }

    return <div className={`situacao-orcamento-btn ${classe}`}>{cell}</div>;
}

export const liberacaoFormatter = (cell, row) => {
    if (isArray(cell)) { cell = cell[0]; }

    let classe = cell ? cell.toLowerCase().replace(/\s|\./g, '-') : "";
    classe = classe.replace('--', '-').replace('_', '-');

    if (cell === null || cell === "") {
        return <div className="text-center">---</div>;
    }
    if (cell.toLowerCase() === "em_analise") {
        cell = "Em Analise"
    }
    return <div className={`liberacao-btn ${classe}`}>{cell.toLowerCase()}</div>;
};

export const situacaoBookingFormater = (cell, row) => {
    if (isArray(cell)) { cell = cell[0]; }

    let classe = cell.toLowerCase().replace(/ /g, '-');
    if (cell.toLowerCase() === "fora do terminal") {
        cell = "Fora term."
    }
    if (cell.toLowerCase() === "programado") {
        cell = "Agendado"
    }
    if (cell.toLowerCase() === "no terminal") {
        cell = "Recebido"
    }

    return <div className={`situacao-btn ${classe}`}>{cell}</div>;
}

export const statusCtrnFormatter = (cell, row) => {
    switch (cell) {
        case 'C': return 'Cheio'
        case 'V': return 'Vazio'
        default: return null
    }
}

export const tipoCtrnFormatter = (cell, row) => {
    switch (cell) {
        case 'V': return 'Refeer'
        case 'F': return 'Dry/Tank'
        default: return null
    }
}

export const statusNotaTranslate = (val) => {
    switch (val) {
        case 'A': return "Associada";
        case 'B': return "Embarcada";
        case 'P': return "Pendente";
        case 'S': return "Saída Gate";
        default: return null
    }
}

export const statusNotaFormatter = (cell, row) => {
    return divStatus(statusNotaTranslate(cell));
}

export const divStatus = (label) => {
    if (!label) return null;
    let classe = label.toLowerCase().replace(/ /g, '-');
    return <div className={`situacao-btn ${classe}`}>{label}</div>
}

export const textFormatter = (cell, row) => {
    return <div className="data-text">
        {cell}
    </div>
}

export const formatarDataMov = (cell, row) => {
    if (cell) {
        const data = moment(cell).format('DD/MM/YYYY - HH:mm:ss').split(' - ')
        return (
            <div className="data-cell">
                {data[0]}
                <span>
                    {data[1]}
                </span>
            </div>
        )

    } else {
        return null
    }
}

export const formatarMovs = (cell, row) => {
    if (cell === 0 || cell === null) {
        return '---'
    } else if (!row) {
        // Versão mobile não envia row para a função
        return (<div>
            {cell}
            <FontAwesomeIcon
                icon="external-link-square-alt"
                className="card-detalhe--pop-color card-detalhe--clickable"
            />
        </div>)
    } else {
        return (
            <div id={`movs_${row.Viagem}`}>
                {cell}
                <FontAwesomeIcon
                    icon="external-link-square-alt"
                    className="card-detalhe--pop-color card-detalhe--clickable"
                />
            </div>
        )
    }
}

export const formatarPopOver = (cell, row) => {
    if (cell === 0 || cell === null) {
        return '---'
    } else if (!row) {
        // Versão mobile não envia row para a função
        return (<div>
            {cell}
            <FontAwesomeIcon
                icon="external-link-square-alt"
                className="ml-1 mb-1 card-detalhe--pop-color card-detalhe--clickable"
            />
        </div>)
    } else {
        return (
            <div id={`movs_${row.Viagem}`}>
                {cell}
                <FontAwesomeIcon
                    icon="external-link-square-alt"
                    className="ml-1 mb-1 card-detalhe--pop-color card-detalhe--clickable"
                />
            </div>
        )
    }
}

export const YesNoFormatter = (cell, row) => {
    switch (cell) {
        case 'S': return 'Sim'
        case 'N': return 'Não'
        default: return null
    }
}



export const appendFieldObjSpan = (cell, row, rowIndex, formatExtraData) => {
    const extraData = formatExtraData.split('-') //separa o nome.objeto (no formato nome-objeto)
    if (cell === 0 || cell === null) {
        return '---'
    } else if (!row) {
        // Versão mobile não envia row para a função
        return (<div>
            <div className="data-cell">
                {cell}<span>{row[extraData[0]][extraData[1]]}</span>
                <FontAwesomeIcon
                    icon="external-link-square-alt"
                    className="ml-1 mb-1 card-detalhe--pop-color card-detalhe--clickable"
                />
            </div>
        </div>)
    } else {
        return (
            <div id={`navio_${row.Navio ? row.Navio.NavioId : ""}`}>
                <div className="data-cell">
                    {cell}
                    <FontAwesomeIcon
                        icon="external-link-square-alt"
                        className="ml-1 mb-1 card-detalhe--pop-color card-detalhe--clickable"
                    />
                    <span>{row[extraData[0]][extraData[1]]}</span>
                </div>
            </div>
        )
    }
}

export const navioDataPopOver = (cell, row, rowIndex, formatExtraData) => {
    const extraData = formatExtraData.split('-') //separa o nome.objeto (no formato nome-objeto)
    if (cell === 0 || cell === null) {
        return '---'
    } else if (!row) {
        // Versão mobile não envia row para a função
        return (<div>
            <div className="data-cell">
                {cell}
                <FontAwesomeIcon
                    icon="external-link-square-alt"
                    className="ml-1 mb-1 card-detalhe--pop-color card-detalhe--clickable"
                />
                <br /><span>{row[extraData[0]][extraData[1]]}</span>
            </div>
        </div>)
    } else if (row.Navio){
        return (
            <div id={`navio_${row.Navio ? row.Navio.NavioId : ""}`}>
                <div className={row.Navio.ServicoNome ? "popover__wrapper" : ""}>
                    <a href="#">
                        {cell}
                        <FontAwesomeIcon
                            icon="external-link-square-alt"
                            className="ml-1 mb-1 card-detalhe--pop-color card-detalhe--clickable"
                        />
                        <br /><span>{row.Navio.Viagem ? row.Navio.Viagem : "---"}</span>
                    </a>
                    <div className="popover__content_right">
                        <Table className="mx-0 px-0" responsive hover striped borderless>
                            <thead >
                                <tr>
                                    <th className="small-title" colSpan="2" width="100%"><b>Detalhes da Operação</b></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="small-title linha borda" colSpan="2" align="center"><b>Dados Gerais</b></td>
                                </tr>
                                <tr>
                                    <td className="small-col" width="50%"><strong>Serviço</strong></td>
                                    <td className="small-col-data" width="50%">{row.Navio.ServicoNome}</td>
                                </tr>
                                <tr>
                                    <td className="small-col" width="50%">Previsão de Início</td>
                                    <td className="small-col-data" width="50%">{row.Navio.EtaFormat}</td>
                                </tr>
                                <tr>
                                    <td className="small-col" width="50%">Previsão de Final</td>
                                    <td className="small-col-data" width="50%">{row.Navio.EtdFormat}</td>
                                </tr>
                                <tr>
                                    <td className="small-col" width="50%">Atracação Real</td>
                                    <td className="small-col-data" width="50%">{row.Navio.ChegadaRealFormat}</td>
                                </tr>
                                <tr>
                                    <td className="small-col" width="50%">Início Real</td>
                                    <td className="small-col-data" width="50%">{row.Navio.InicioRealFormat}</td>
                                </tr>
                                <tr>
                                    <td className="small-col" width="50%">Fim Real</td>
                                    <td className="small-col-data" width="50%">{row.Navio.FimRealFormat}</td>
                                </tr>
                                <tr>
                                    <td className="small-col" width="50%">Desatracação</td>
                                    <td className="small-col-data" width="50%">{row.Navio.PartidaRealFormat}</td>
                                </tr>
                                <tr>
                                    <td className="small-title linha" colSpan="2" align="center"><b>Recebimento da Carga e Container</b></td>
                                </tr>
                                <tr>
                                    <td className="small-col" width="50%">Início Cheio</td>
                                    <td className="small-col-data" width="50%">{row.Navio.InicioRecebCheioFormat}</td>
                                </tr>
                                <tr>
                                    <td className="small-col" width="50%">Início Vazio</td>
                                    <td className="small-col-data" width="50%">{row.Navio.InicioRecebVazioFormat}</td>
                                </tr>
                                <tr>
                                    <td className="small-col linha borda" width="50%">Deadline Cheio</td>
                                    <td className="small-col-data linha borda" width="50%">{row.Navio.DeadlineDryFormat}</td>
                                </tr>
                                <tr>
                                    <td className="small-col linha borda" width="50%">Deadline Vazio </td>
                                    <td className="small-col-data linha borda" width="50%">{row.booking.VesselDeadLineEmptyFormat}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>
        )
    }
}

export const movsPopOver = (cell, row, rowIndex, formatExtraData) => {
    if (cell === 0 || cell === null) {
        return '---'
    } else if (!row) {
        // Versão mobile não envia row para a função
        return (<div>
            {cell}
            <FontAwesomeIcon
                icon="external-link-square-alt"
                className="card-detalhe--pop-color card-detalhe--clickable"
            />
        </div>)
    } else {
        return (
            <div id={`movs_${row.Viagem ? row.Viagem : ""}`}>
                <div className={row.Viagem ? "popover__wrapper" : ""}>
                    <div>
                        {cell}
                        <FontAwesomeIcon
                            icon="external-link-square-alt"
                            className="ml-1 mb-1 card-detalhe--pop-color card-detalhe--clickable"
                        />
                    </div>
                    <div className="popover__content_left content-narrow">
                        <Table className="mx-0 px-0" responsive hover striped borderless>
                            <tbody>
                                <tr>
                                    <td className="small-title-th" colSpan="2" width="100%"><b>Movimentos de Operação <span className="span-text-destaque">{row.Viagem}</span></b></td>
                                </tr>
                                <tr>
                                    <td className="small-title linha borda" colSpan="2" align="center"><b>Movs {row.Movs}</b></td>
                                </tr>
                                <tr>
                                    <td className="small-col" width="50%"><strong>Carga</strong></td>
                                    <td className="small-col-data" width="50%">{formatNullableValue(row.Load)}</td>
                                </tr>
                                <tr>
                                    <td className="small-col" width="50%">Descarga</td>
                                    <td className="small-col-data" width="50%">{formatNullableValue(row.Discharge)}</td>
                                </tr>
                                <tr>
                                    <td className={process.env.rig ? "small-col" : "small-col linha borda"} width="50%">Remoção</td>
                                    <td className={process.env.rig ? "small-col-data" : "small-col-data linha borda"} width="50%">{formatNullableValue(row.Remocao)}</td>
                                </tr>
                                {process.env.rig &&
                                    <tr>
                                        <td className="small-col linha borda" width="50%">Carga Geral</td>
                                        <td className="small-col-data linha borda" width="50%">{formatNullableValue(row.VolumeCg)}</td>
                                    </tr>}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>
        )
    }
}
export const agendamentoServPopOver = (cell, row, rowIndex, formatExtraData) => {
    if (cell === 0 || cell === null) {
        return '---'
    } else if (!row) {
        // Versão mobile não envia row para a função
        return (<div>
            {cell}
            <FontAwesomeIcon
                icon="external-link-square-alt"
                className="card-detalhe--pop-color card-detalhe--clickable"
            />
        </div>)
    } else {
        let randomId = Math.floor(Math.random() * 10000) + 1;
        return (
            <div id={`cntr_${row.AgendServId ? row.AgendServId : ""}`}>
                <div className={row.AgendServId ? "popover__wrapper" : ""}>
                    <a href="#">
                        {cell}
                        <FontAwesomeIcon
                            icon="external-link-square-alt"
                            className="ml-1 mb-1 card-detalhe--pop-color card-detalhe--clickable"
                        />
                    </a>
                    <div id={`${randomId}`} className="popover__content_left content-narrow">
                        <Table className="mx-0 px-0" responsive hover striped borderless>
                            <tbody>
                                <tr>
                                    <td className="small-title-th" colSpan="2" width="100%"><b>Containers do agendamento</b></td>
                                </tr>
                                <tr>
                                    <td className="small-title linha borda" align="center"><b>{`${row.QtdCntrAgend} ${row.QtdCntrAgend > 1 ? " encontrados" : "encontrado"}`}</b></td>
                                </tr>
                                {
                                    row.ListItens.map(cntr => {
                                        return <tr>
                                            <td className="small-col-data linha" align="center"><b>{cntr.CodCntr}</b></td>
                                        </tr>
                                    })
                                }
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>
        )
    }
}

export const formatarLink = (cell, row, rowIndex, formatExtraData) => {
    return (<div>
        <Link to={{
            pathname: formatExtraData.link,
            state: {
                notaTecon: cell,
                voltar: formatExtraData.voltar
            }
        }}>{cell}
        </Link>
    </div>)
}

export const appendFieldSpan = (cell, row, rowIndex, formatExtraData) => {
    return <div className="data-cell">{cell}<span>{formatExtraData ? row[formatExtraData] : "---"}</span></div>
};

export const appendField = (cell, row, rowIndex, formatExtraData) => {
    let valorCelula = cell ? cell : " - ";
    let valorCelulaAdicional = row[formatExtraData] ? row[formatExtraData] : " - ";

    return <div className="data-cell">{valorCelula} / {valorCelulaAdicional}</div>
};

export const appendFieldDadosGerais = (dado, outroDado) => {
    if (Array.isArray(dado)) {
        if (dado.length === 0) return <div className="data-cell"> - </div>
        if (dado.length === 1) return <div className="data-cell"> {dado[0]} </div>
        return <div className="data-cell">{dado[0]} / {dado[1]}</div>
    } else {
        if (!dado || !outroDado) return <div className="data-cell"> - </div>
        return <div className="data-cell">{dado} / {outroDado}</div>
    }
};

export const exibirItensArray = (cell, row, rowIndex, formatExtraData) => {
    let multiplosItens = cell.map((e) => e[formatExtraData]);
    return multiplosItens.map((val, index) => <div key={index} className="d-block">{val}</div>);
};

export const objetoParaQueryString = (arr) => {
    return Object.keys(arr).map(key => key.toLowerCase() === "situacoes" ? montarParametrosSituacao(arr[key]) : `${key}=${encodeURIComponent(arr[key])}`).join('&');
};

export const isArray = (value) => {
    return value && typeof value === 'object' && value.constructor === Array;
};

export const isObject = (value) => {
    return value && typeof value === 'object' && value.constructor === Object;
};

export const montarParametrosSituacao = (arr) => {
    let situacoes = arr.split(',');
    situacoes = situacoes.map((e) => objetoParaQueryString({ "situacao": e })).join('&');
    return arr && situacoes.length > 0 ? situacoes : '';
};

//Criada a opção sort
export const montarSelectOption = (value, label, array, sort = true) => {
    let options = [];
    if (array)
        array.map(e => options.push({ value: _.get(e, value), label: _.get(e, label) ? _.get(e, label) : "" }));

    function compara(a, b) {
        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
    }

    // Verificando se ordena
    if (sort)
        options = options.sort(compara);

    return options;
};

export const montarSelectOptionComCNPJ = (value, label, cnpj ,array, sort = true) => {
    let options = [];
    if (array)
        array.map(e => options.push({ value: _.get(e, value), label: _.get(e, label) ? _.get(e, label) : "" , cnpj: _.get(e, cnpj)}));

    function compara(a, b) {
        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
    }

    // Verificando se ordena
    if (sort)
        options = options.sort(compara);

    return options;
};

export const montarSelectOptionArray = (value, label, array, arraySelect) => {
    let options = [];
    let index = -1;
    let optIndex = -1;

    if (array) {
        array.map(e => options.push({ value: _.get(e, value), label: _.get(e, label) }));
        if (arraySelect) {
            for (let i = 0; i < arraySelect.length; i++) {
                index = arraySelect[i]["value"];
                if (index >= 0 && index != null) {
                    if (options.length > 0) {
                        for (let j = 0; j < options.length; j++) {
                            if (options[j].value === index) {
                                optIndex = j;
                                break;
                            }
                        }
                    }
                    if (optIndex >= 0)
                        options.splice(optIndex, 1);
                }
            }
        }
    }

    function compara(a, b) {
        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
    }

    options = options.sort(compara);
    return options;
};

export const dataSortFunc = (a, b, order, field, rowA, rowB) => {
    const dataA = new Date(moment(rowA.Data).year(), moment(rowA.Data).month(), moment(rowA.Data).date(), rowA.Hora);
    const dataB = new Date(moment(rowB.Data).year(), moment(rowB.Data).month(), moment(rowB.Data).date(), rowB.Hora);

    if (order === 'desc')
        return moment(dataA, "DD/MM/YYYY HH:00") - moment(dataB, "DD/MM/YYYY HH:00");
    else
        return moment(dataB, "DD/MM/YYYY HH:00") - moment(dataA, "DD/MM/YYYY HH:00");
}

export const dataSortFuncString = (a, b, order, field, rowA, rowB) => {
    const getDateTimeInMilliseconds = (dateTimeStr) => {
        if (!dateTimeStr) return 0; 
        
        const [date, time] = dateTimeStr.split(' ');
        const [day, month, year] = date.split('/');
        const [hours, minutes] = time.split(':');
        
        
        return new Date(year, month - 1, day, hours, minutes).getTime();
    };

    
    const dateTimeA = getDateTimeInMilliseconds(rowA[field]);
    const dateTimeB = getDateTimeInMilliseconds(rowB[field]);

    // Comparação baseada na ordem
    if (order === 'desc') {
        return dateTimeB - dateTimeA;
    } else {
        return dateTimeA - dateTimeB;
    }
};

export const numericSortFunc = (a, b, order) => {
    console.log(Number(b) - Number(a))
    if (order === 'desc') {
        return Number(b) - Number(a);
    } else {
        return Number(a) - Number(b);
    }
}


export const montarSelectionBooking = (value, array) => {
    let options = []
    if (array)
        array.map(e => options.push({ value: _.get(e, value), label: `${_.get(e, 'Operacao').replace(`${_.get(e, 'Navio')} - `, '')} - ${_.get(e, 'NavioNome')}` }))
    return options
}

export const setTemaSeletor = theme => ({
    ...theme,
    colors: {
        ...theme.colors,
        primary25: '#CCD1D9',
        primary50: '#99A4B3',
        primary: '#001C43',
    },
});

/**
 * 
 * @param {any} data - São os dados que se deseja imprimir
 * @param {Array<String>} paramArray - Array com os parametros contidos em data que se deseja imprimir
 * @param {Array<String>} headerArray - Array com os headers da tabela
 * @param {Array<Sting>} timeArray - Array com os valores definidos no array de parametros que são para conversão
 * @param {Array<Object>} appendArray - Array com objetos contendo o valor a ser adicionado a outro valor
 *                                      O objeto deve ser descrito como: {input: <String>, append: <String>}
 * @param {Boolean} toDownload - Se for para download assim que o pdf for gerado, utilize true
 */

export const makePDF = (data, paramArray, headerArray, timeArray, appendArray = [], toDownload, ...params) => {
    let param = params[0]

    let printData = data.map((elem, index) => {
        return (paramArray.map((param) => {
            if (foundInArray(param, timeArray) && elem[param] !== null) {
                return moment(elem[param]).format("DD/MM/YYYY HH:mm")
            } else if (elem[param] === undefined || elem[param] === null) {
                return ""
            } else if (params[0] && params[0].format && params[0].format.length > 0 && params[0].format.find(f => f.param === param)) {
                const objFormat = params[0].format.find(f => f.param === param);
                return objFormat.formatter(elem[param]);
            } else {
                return elem[param]
            }
        }))
    })

    if (appendArray.length > 0) {
        appendArray.map(elem => {
            const replace = paramArray.indexOf(elem.input)
            if (replace !== -1) {
                printData.map((print, index) => {
                    const add = data[index][elem.append]
                    print[replace] = `${print[replace]} - ${add}`
                })
            }
        })
    }

    let pdfOutput = {
        pageOrientation: headerArray.length > 5 ? 'landscape' : 'portrait',
        pageSize: !(param && param.qtdColFixo) ? pageSizeCalc(headerArray.length) : param.qtdColFixo,
        content: [
            {
                style: 'tableExample',
                table: {
                    body: [
                        headerArray,
                        ...printData
                    ]
                }
            }
        ]

    }
    if (param && param.nomeDoArquivo)
        pdfMake.createPdf(pdfOutput).download(param.nomeDoArquivo)
    else pdfMake.createPdf(pdfOutput).download()
    //toDownload ? pdfMake.createPdf(pdfOutput).download() : pdfMake.createPdf(pdfOutput).open() 
}

export const makeBookingPDF = (booking,itens,containers) => {
        var bookingInfo = [
         booking.Nbr
        ,booking.VesselVisit+' '+booking.VesselName
        ,booking.LineOperator
        ,booking.VesselDeadLineFormat
        ,booking.Pod
        ,booking.Destination
        ,itens[0].Tipo
        ,booking.QtdAgendBkn
        ,booking.Quantity
        ,itens[0].Patio
        ,itens[0].Saida
        ,booking.Status
    ]

    var capacityInfo = [];
    itens.map(x=>{
        console.log('x é')
        console.log(x)
        var capacityLine = [x.Tipo,x.Qtd,x.Un,x.Temperature,x.Imo,x.Reefer == 1? 'SIM':'NÃO',x.Hazardous == 1? 'SIM':'NÃO',x.Oog == 1? 'SIM':'NÃO']
        capacityInfo.push(capacityLine)
    })

    var containersInfo = []
    containers.map(x=>{
        console.log('y é')
        console.log(x)
        
        var containersLine = [x.Container,
            x.Tipo,
            x.LineOperator,
            formataParaDiaMesAnoHoraMinuto(x.TimeIn),
            formataParaDiaMesAnoHoraMinuto(x.DatEntrega),
            x.Iso,
            x.Situacao
        ]
        containersInfo.push(containersLine)
    })


    let pdfOutput = {
        pageOrientation: 'landscape', 
        //pageSize: !(param && param.qtdColFixo) ? pageSizeCalc(headerArray.length) : param.qtdColFixo,
        content: [
            {
                style: 'tableExample',
                table: {
                    title:'titulo',
                    widths: '*',
                    body: [
                        [{text: 'BOOKING', alignment: 'center'}]
                    ]
                }
            },
            ,{
                style: 'tableExample',
                table: {
                    body: [
                        ['Numero Booking','Navio/Viagem','Armador','Deadline Op','Porto Desc','Destino','TAM/Tipo','QTD. Agendados','QTD Prev','Pátio','saída','situação navio'],
                        bookingInfo
                    ]
                }
            },
            {
                style: 'tableExample',
                table: {
                    title:'titulo',
                    widths: '*',
                    body: [
                        [{text: 'CAPACIDADES', alignment: 'center'}]
                    ]
                }
            },
            {
                style: 'tableExample',
                table: {
                    title:'titulo',
                    widths: '*',
                    body: [
                        ['TIPO','QTD','UN','TEMP','IMO','REEFER','PERIGOSA','OVER DIMENSION'],
                        ...capacityInfo
                    ]
                }
            },
            {
                style: 'tableExample',
                table: {
                    title:'titulo',
                    widths: '*',
                    body: [
                        [{text: 'CONTAINERS', alignment: 'center'}]
                    ]
                }
            }
            ,{
                style: 'tableExample',
                table: {
                    widths: '*',
                    body: [
                        ['Numero Container','TIPO','ARMADOR','DATA ENTRADA','DATA SAIDA','ISO','STATUS'],
                        ...containersInfo
                    ]
                }
            }
        ]

    }
    pdfMake.createPdf(pdfOutput).download('booking')

}

/**
 * 
 * @param {any} value - Valor que desejamos encontrar dentro de um Array
 * @param {Array<any>} array
 */

export const foundInArray = (value, array) => {
    if (array.length !== 0) {
        const find = array.find(el => el === value)
        if (find && find.length > 0) {
            return true
        } else {
            return false
        }
    }
}

export const pageSizeCalc = (size) => {
    if (size >= 1 && size < 10)
        return 'A4'
    if (size >= 10 && size < 20)
        return 'A3'
    if (size >= 20 && size < 25)
        return 'A2'
    if (size >= 25 && size < 30)
        return 'A1'
    if (size >= 30)
        return 'A0'
}

export const formatNullableValue = (value) => {
    if (value == null) return "---";
    if (value == "") return "---";
    return value;

}

export const splitBR = (msg) => {
    if (msg) {
        if (msg.indexOf("<br />") != -1) return msg.split("<br />").filter(Boolean);
        if (msg.indexOf("<br>") != -1) return msg.split("<br>").filter(Boolean);
        if (msg.indexOf("<br/>") != -1) return msg.split("<br/>").filter(Boolean);
        return [msg];
    }
    return [];
}

export const splitQuebraLinha = (msg) => {
    if (msg) {
        let newText = [];

        if (msg.indexOf("<br />") != -1) {
            newText = msg.split("<br />").map((item, i) => {
                return <h2 key={i}>{item}</h2>;
            });
        }
        if (msg.indexOf("<br>") != -1) {
            newText = msg.split("<br>").map((item, i) => {
                return <h2 key={i}>{item}</h2>;
            });
        }
        if (msg.indexOf("<br/>") != -1) {
            newText = msg.split("<br/>").map((item, i) => {
                return <h2 key={i}>{item}</h2>;
            });
        }

        return [newText];
    }
    return [];
}

export const listEmailFormatter = (emailList) => {
    if (emailList !== "") {
        const emails = emailList.split(",")
        return (
            <span>
                {emails.map((email, index) => (
                    <div key={index}>
                        {email}
                    </div>
                ))}
            </span>
        )
    }
}

export const formatarInfoAvaria = (cell, row) => {
    return (
        <div className={`situacao-wire ${cell === "S" ? "sim" : "nao"}`}>
            {cell === "S" ? "Sim" : "Não"}
        </div>
    )
}

export const formatarDivergenciaLacre = (cell, row) => {
    return (
        <div className={`situacao-wire ${cell === 0.0 ? "sim" : "nao"}`}>
            {cell === 0.0 ? "Sim" : "Não"}
        </div>
    )
}


export const formatarInfoPerigoso = (cell, row) => {
    return (
        <div className={`situacao-wire ${cell === "Sim" ? "sim" : "nao"}`}>
            {cell === "Sim" ? "Sim" : "Não"}
        </div>
    )
}

export const formatNavioViagemComBarra = (cell) => {
    if (!cell) return "---"
    else {
        const data = cell.split("/")
        return (
            <div>
                <div className="data-cell">
                    {data[0]}
                </div>
                <span>
                    {data[1]}
                </span>
            </div>
        )
    }
}

export const formatarDataDireto = (cell) => {
    if (!cell) return "---"
    else {
        return (
            <div>
                <div className="data-cell">
                    {moment(cell).format("DD MMM, YYYY")}
                </div>
                <span>
                    {moment(cell).format("HH:mm")}
                </span>
            </div>
        )
    }
}

export const formatarListaHoras = (listaHoras) => {
    let options = [];
    if (listaHoras) listaHoras.map(e => {

        let hora = parseInt(e.Hora, 10);
        let lbl = "";
        let tipo = e.FlgVaga;
        switch (tipo) {
            case "N": lbl = <LegendaNormalCirculo label={`${hora}:00  até  ${hora + 1}:00`} />; break;
            case "G": lbl = <LegendaGoldCirculo label={`${hora}:00  até  ${hora + 1}:00`} />; break;
            case "E": lbl = <LegendaEsgotadoCirculo label={`${hora}:00  até  ${hora + 1}:00`} />; break;
            default: lbl = <LegendaIndisponivelCirculo label={`${hora}:00  até  ${hora + 1}:00`} />; break;
        }
        options.push({ value: hora, label: lbl, AgendGold: (tipo === "G") ? "S" : "N" })
    });
    return options;
};

//formatarListaHorasDeadLine
export const formatarListaHorasDeadLine = (listaHoras, horaLimite) => {
    let options = [];
    if (listaHoras) listaHoras.map(e => {

        let hora = parseInt(e.Hora, 10);
        let lbl = "";
        let tipo = e.FlgVaga;
        
        if(horaLimite === 999){//Hora de agendamento esgotada.
            lbl = <LegendaEsgotadoCirculo label={`${hora}:00  até  ${hora + 1}:00`} />;
        }
        else{
            switch (tipo) {
                case "N": 
                    if(hora > horaLimite){
                        lbl = <LegendaEsgotadoCirculo label={`${hora}:00  até  ${hora + 1}:00`} />;
                    }
                    else{
                        lbl = <LegendaNormalCirculo label={`${hora}:00  até  ${hora + 1}:00`} />; 
                    }                
                    break;
                case "G": lbl = <LegendaGoldCirculo label={`${hora}:00  até  ${hora + 1}:00`} />; break;
                case "E": lbl = <LegendaEsgotadoCirculo label={`${hora}:00  até  ${hora + 1}:00`} />; break;
                default: lbl = <LegendaIndisponivelCirculo label={`${hora}:00  até  ${hora + 1}:00`} />; break;
            }
        }
        options.push({ value: hora, label: lbl, AgendGold: (tipo === "G") ? "S" : "N" })
    });
    return options;
};

export const formatarListaDatas = (listaDatas, campo) => {
    let options = [];
    if (listaDatas) listaDatas.map(e => {
        let data = e[campo];
        let diaSemana = e.DiaSemana ? `${e.DiaSemana} - ` : "";
        options.push({ value: data, label: `${diaSemana}${moment(data).format("DD/MM/YYYY")}` })
    });
    return options;
};

export const somenteNumeros = valor => valor.replace(/[^-0-9]+/g, '')


// WEBPACK FOOTER //
// ./src/utils/formatar.js